export default __webpack_public_path__ + "static/whatsappPageHeroBgMobile-ed3086072aea19674669664efe808f70.png";